<template>
  <div style="position: fixed; bottom: 5px; width: 400px; left: calc(50% - 200px); z-index: 6000;" v-if="allerts.length > 0">

    <v-alert
        rounded="xl"
        density="compact"
        v-for="allert in allerts" :key="allert"
        style="background: white"
        :color="allert.color"
        variant="outlined"
        prominent
        border="top"
        class="ma-1"
    >
      <template v-slot:title>
        {{allert.title}}
      </template>
      <template v-slot:text>
        <v-sheet v-html="allert.text" />
      </template>
      <template v-slot:prepend>
        <v-icon :icon="allert.icon" />
      </template>
    </v-alert>
  </div>
</template>

<script>
import { Allerts } from "@/store/global/Allerts";

export default {
  name: "AllertComponent",
  computed: {
    allerts: {
      get() {
        return Allerts().get()
      },
      set(value) {
        Allerts().set(value)
      }
    }
  }
}
</script>

<style scoped>

</style>
